import { render, staticRenderFns } from "./TheDocumentVersions.vue?vue&type=template&id=583bcced&scoped=true&"
import script from "./TheDocumentVersions.vue?vue&type=script&lang=js&"
export * from "./TheDocumentVersions.vue?vue&type=script&lang=js&"
import style0 from "./TheDocumentVersions.vue?vue&type=style&index=0&id=583bcced&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583bcced",
  null
  
)

export default component.exports